<ejs-tooltip [content]="this.toolTipText != '' ? this.toolTipText : ''">{{this.displayText != "" ? this.displayText : ""}}</ejs-tooltip>